import { compact } from 'lodash';
import { useMemo } from 'react';

import { BigBreadcrumbs } from '@/components/navigation/BigBreadcrumbs';

interface EstateBreadcrumbProps {
  pageCrumb?: string;
  householdId: string;
}

export function EstateBreadcrumb({ pageCrumb }: EstateBreadcrumbProps) {
  const crumbs = useMemo(() => {
    return compact([
      pageCrumb && {
        label: pageCrumb,
      },
    ]);
  }, [pageCrumb]);

  return <BigBreadcrumbs crumbs={crumbs} />;
}
